import React from 'react'
import ReactDOM from 'react-dom'

import AppPackLive from './AppPackLive'

const el = document.getElementById('root');
ReactDOM.render(<AppPackLive env={el.getAttribute('data-env')} devmode={el.getAttribute('data-devmode')} params={el.getAttribute('data-params')} mode={el.getAttribute('data-mode')} />, document.getElementById('root'))